module.exports = __webpack_public_path__ + "img/unity.d56d45bb.svg";